<template>
  <div>
    <v-container class="pt-0">
      <span v-if="showHeader" class="headline">{{$t('premium.title')}}</span>
      <v-row v-if="subscriptionInfo">
        <v-col cols="12" v-if="subscriptionInfo.premium">
          <info-block icon="mdi-star-circle-outline" iconClass="premium-icon">
            <div class="ml-1">
              <span>
                {{$t('premium.yeah-you-are-in')}}
              </span>
              <div v-if="subscriptionInfo.premiumUntil">
                <span class="caption">{{$t('premium.your-premium-is-active-until', {date: $datefns.formatRelative(subscriptionInfo.premiumUntil)})}}</span>
              </div>
            </div>
          </info-block>
        </v-col>
        <v-col cols="12" v-else>
          <info-block>{{$t('premium.you-dont-have-premium-yet')}}</info-block>
        </v-col>
        <v-col cols="12" v-if="subscriptionInfo.cancelled">
          <info-block>{{$t('premium.oh-your-premium-was-cancelled')}}</info-block>
        </v-col>
      </v-row>
      <div v-if="$nativeApp.isIOS()">
        <v-row>
          <v-col cols="12">
            {{$t('premium.ios-premium-not-available-yet')}}
          </v-col>
        </v-row>
        <v-row v-if="subscriptionInfo.premium == false">
          <v-col cols="12">
            <premium-coupon-form/>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row v-if="subscriptions && subscriptionInfo && subscriptionInfo.premium == false">
          <v-col cols="12" v-for="subscription in subscriptions" :key="subscription.plan">
            <v-btn class="secondary"
              @click="function() {subscribePlan(subscription.plan);}"
              style="text-transform:inherit;"
            >
              <v-icon left>mdi-star-circle-outline</v-icon>
              {{subscription.name}} {{subscription.cost}} €
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            v-if="subscriptions.length==0"
          >
            <info-block>{{$t('premium.no-subscriptions-available')}}</info-block>
          </v-col>
        </v-row>
        <v-row v-if="premiumProducts && subscriptionInfo && subscriptionInfo.premium == false">
          <v-col cols="12" v-if="premiumProducts.length > 0">
            <span class="caption">{{$t('premium.simple-product-introduction')}}</span>
          </v-col>
          <v-col cols="12" v-for="product in premiumProducts" :key="product.sku">
            <v-btn class="secondary"
              @click="function() {openPurchaseProduct(product);}"
              style="text-transform:inherit;"
            >
              <v-icon left>mdi-star-circle-outline</v-icon>
              {{product.name}} {{purchaseValueToString(product.total)}}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="subscriptionInfo && subscriptionInfo.premium == true">
          <v-col cols="12" v-if="subscriptionInfo.cancelled == false">
            <v-btn @click="cancelSubscription" class="warning">
              <v-icon left>mdi-close-circle</v-icon>{{$t('premium.cancel-subscription')}}
            </v-btn>
          </v-col>
          <v-col cols="12" v-if="subscriptionInfo.cancelled == true">
            <v-btn @click="cancelSubscriptionNow" class="error">
              <v-icon left>mdi-close-circle</v-icon>{{$t('premium.cancel-subscription-now')}}
            </v-btn>
            <br />
            <span class="overline">{{$t('premium.cancel-subscription-now-description')}}</span>
          </v-col>
        </v-row>
        <v-row v-if="subscriptionInfo && subscriptionInfo.premium == false">
          <v-col cols="12">
            <premium-coupon-form/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <pricelist-content :showHeader="false" />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import PricelistContent from "@/components/content/PricelistContent";
import PremiumCouponForm from "@/widgets/PremiumCouponForm";
import subscription from "@/mixins/subscription";
import purchaseProduct from "@/mixins/purchaseProduct";
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import InfoBlock from "@/widgets/InfoBlock";

export default {
  name: "Subscription",
  mixins: [subscription, purchaseProduct],
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PricelistContent,
    PremiumCouponForm,
    InfoBlock,
  },

  data: () => ({
    subscriptions: undefined,
    premiumProducts: undefined,
    subscriptionInfo: undefined
  }),
  mounted() {
    this.refresh();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.refresh);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.refresh);
  },
  methods: {
    refresh: function() {
      this.subscriptionInfo = undefined;
      this.$api
        .getSubscriptionInfo()
        .then(res => {
          this.subscriptionInfo = res.data;
        })
        .catch(error => {
          this.$common.onError(error)
        });
      this.$api.getSubscriptions().then(res => {
        this.subscriptions = res.data.list;
      });
      this.$api.getPremiumProducts().then(res => {
        this.premiumProducts = res.data.list;
      });
    },
    cancelSubscription: function() {
      this.$api
        .cancelSubscription()
        .then(() => {
          this.refresh();
        })
        .catch(error => {
          this.$common.onError(error)
        });
    },
    cancelSubscriptionNow: function() {
      this.$api
        .cancelSubscription({ now: true })
        .catch(error => {
          this.refresh();
          this.$common.onError(error)
        })
        .catch(error => {
          this.$common.onError(error)
        });
    },
    openPurchaseProduct(product) {
      this.purchaseProduct(product.sku) // mixin
    },
  }
};
</script>
